var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeleteCircleRed = function SvgDeleteCircleRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.5.2.9-Setup-/-Company-/-Company-details---create-project--view-action",
    transform: "translate(-1004.000000, -687.512412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-action",
    transform: "translate(988.000000, 526.511337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(0.000000, 14.001075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "close-circle",
    mask: "url(#mask-2)",
    fill: "#DB3D49",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.333333, 3.333333)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.77083333,0 C3.0374349,0 0,3.0374349 0,6.77083333 C0,10.5042318 3.0374349,13.5416667 6.77083333,13.5416667 C10.5042318,13.5416667 13.5416667,10.5042318 13.5416667,6.77083333 C13.5416667,3.0374349 10.5042318,0 6.77083333,0 Z M9.22233073,8.4860026 C9.35953709,8.61635661 9.41523508,8.81087998 9.3678141,8.99409844 C9.32039311,9.1773169 9.1773169,9.32039311 8.99409844,9.3678141 C8.81087998,9.41523508 8.61635661,9.35953709 8.4860026,9.22233073 L6.77083333,7.50748698 L5.05566406,9.22233073 C4.85089099,9.41687702 4.52836924,9.41274773 4.32864409,9.21302258 C4.12891894,9.01329742 4.12478964,8.69077568 4.31933594,8.4860026 L6.03417969,6.77083333 L4.31933594,5.05566406 C4.12478964,4.85089099 4.12891894,4.52836924 4.32864409,4.32864409 C4.52836924,4.12891894 4.85089099,4.12478964 5.05566406,4.31933594 L6.77083333,6.03417969 L8.4860026,4.31933594 C8.69077568,4.12478964 9.01329742,4.12891894 9.21302258,4.32864409 C9.41274773,4.52836924 9.41687702,4.85089099 9.22233073,5.05566406 L7.50748698,6.77083333 L9.22233073,8.4860026 Z"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteCircleRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-circle-red.22c75332.svg";
export { ForwardRef as ReactComponent };